export {htmlLegendPlugin, getLegendList}

const getLegendList = (chart, id) => {
  const legendContainer = document.getElementById(id);
  let listContainer = legendContainer.querySelector("ul");

  if (!listContainer) {
    listContainer = document.createElement("ul");
    listContainer.style.display = "flex";
    listContainer.style.flexWrap = "wrap";
    listContainer.style.flexDirection = "row";
    listContainer.style.margin = 0;
    listContainer.style.padding = 0;

    legendContainer.appendChild(listContainer);
  }

  return listContainer;
};

const htmlLegendPlugin = {
  id: "htmlLegend",
  afterUpdate(chart, args, options) {
    const ul = getLegendList(chart, options.containerID);

    while (ul.firstChild) {
      ul.firstChild.remove();
    }

    const items = chart.options.plugins.legend.labels.generateLabels(chart);

    items.forEach((item) => {
      console.log(item)
      const li = document.createElement("li");
      li.style.alignItems = "center";
      li.style.cursor = "pointer";
      li.style.display = "flex";
      //li.style.flexWrap = "wrap";
      li.style.flexDirection = "row";
      li.style.marginLeft = "10px";
      li.style.flex = "1 1 44%";
      li.style.marginBottom = "4px";

      li.addEventListener("click", function () {
        const { type } = chart.config;
        if (type === "pie" || type === "doughnut") {
          chart.toggleDataVisibility(item.index);
        } else {
          chart.setDatasetVisibility(
            item.datasetIndex,
            !chart.isDatasetVisible(item.datasetIndex)
          );
        }
        chart.update();
      });

      const boxSpan = document.createElement("canvas");
      const ctx = boxSpan.getContext('2d');
    
      boxSpan.style.borderWidth = item.lineWidth + "px";
      boxSpan.style.display = "inline-block";
      boxSpan.style.height = "20px";
      boxSpan.style.width = "20px";
      boxSpan.style.marginRight = "10px";
      boxSpan.style.marginBottom = "0px";

      ctx.fillStyle = item.fillStyle;
      ctx.strokeStyle = item.strokeStyle;
      //ctx.setTransform(new DOMMatrix('scale(12,6)'));
      ctx.scale(12,6)
      ctx.fillRect(0, 0, boxSpan.width, boxSpan.height)

      const textContainer = document.createElement("p");
      textContainer.style.color = item.fontColor;
      textContainer.style.fontSize = "0.7rem";
      textContainer.style.margin = 0;
      textContainer.style.padding = 0;
      textContainer.style.textDecoration = item.hidden ? "line-through" : "";

      const text = document.createTextNode(item.text);
     
      textContainer.appendChild(text);

      li.appendChild(boxSpan);
      li.appendChild(textContainer);
      ul.appendChild(li);
    });
  },
};
